/**
 * Hematologie — specialty manifest.
 *
 * Maintained through the Specialty Registry. The manifest is data: the shell
 * reads it and knows nothing about this specialty.
 *
 * Legacy codes resolved here: HEMA
 * Catalogue acts (NGAP Maroc): 0
 */
import { defineSpecialty } from "../types";

export const hematologie = defineSpecialty(
{
  "id": "hematologie",
  "label": "Hematologie",
  "short": "hematologie",
  "scope": "Maladies du sang, hémostase, transfusion et oncologie hématologique",
  "aliases": [
    "HEMA"
  ],
  "doctorSpecs": [
    "Hématologie"
  ],
  "featureFlag": "ux.v2.hematologie",
  "theme": {
    "primary": "oklch(0.64 0.19 15)",
    "primaryForeground": "oklch(0.98 0.005 240)",
    "accent": "oklch(0.78 0.16 80)",
    "accentForeground": "oklch(0.18 0.02 240)",
    "destructive": "oklch(0.65 0.22 27)",
    "success": "oklch(0.78 0.18 150)",
    "warning": "oklch(0.78 0.16 80)",
    "surface": "oklch(0.205 0.006 240)",
    "radius": "0.75rem",
    "fontDisplay": "\"Inter\", ui-sans-serif, system-ui, sans-serif"
  },
  "navigation": [
    {
      "id": "consult",
      "label": "Consultation",
      "icon": "Stethoscope",
      "route": "/clinical/consult",
      "order": 1,
      "requires": []
    },
    {
      "id": "lab",
      "label": "Laboratoire",
      "icon": "FlaskConical",
      "route": "/clinical/lab",
      "order": 2,
      "requires": [
        "lims"
      ]
    },
    {
      "id": "transfusion",
      "label": "Transfusion",
      "icon": "Droplet",
      "route": "/clinical/transfusion",
      "order": 3,
      "requires": []
    },
    {
      "id": "prescription",
      "label": "Ordonnance",
      "icon": "Pill",
      "route": "/clinical/prescription",
      "order": 5,
      "requires": []
    }
  ],
  "panels": [
    {
      "id": "labs",
      "label": "Hémogramme",
      "icon": "FlaskConical",
      "component": "LabResultsGrid",
      "order": 1,
      "requires": []
    },
    {
      "id": "coag",
      "label": "Coagulation",
      "icon": "Activity",
      "component": "CoagulationPanel",
      "order": 2,
      "requires": []
    },
    {
      "id": "timeline",
      "label": "Chronologie",
      "icon": "History",
      "component": "PatientTimeline",
      "order": 3,
      "requires": []
    }
  ],
  "ngap": {
    "specialtyScope": "Hématologie",
    "subSpecialties": [
      "Consultation",
      "Hémostase",
      "Transfusion",
      "Hémogramme"
    ],
    "catalogueActs": 0
  },
  "terminology": {
    "icd10": [
      "D50",
      "D58",
      "D61",
      "D68"
    ],
    "loinc": [
      "789-8",
      "6301-6",
      "34714-6"
    ],
    "snomed": []
  },
  "deviceProfiles": [
    "hematology-analyzer",
    "coagulometer",
    "plasma-thawer"
  ],
  "locales": [
    "fr",
    "ar"
  ]
}
);

export default hematologie;
